var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRpoetSubCat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2891,
    cy: 25.5,
    r: 25,
    fill: "#9C4900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_67982",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 31,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.2891,
    y: 10.5,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_67982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6641 19.7017V38H15.9141V13H27.9624L34.6641 19.7017ZM28.4141 19.25H31.9907L28.4141 15.6733V19.25ZM33.1016 36.4375V20.8125H26.8516V14.5625H17.4766V36.4375H33.1016ZM23.7266 30.1875H26.8516V34.875H23.7266V30.1875ZM19.0391 27.0625H22.1641V34.875H19.0391V27.0625ZM28.4141 23.9375H31.5391V34.875H28.4141V23.9375Z",
    fill: "#F6EFE9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpoetSubCat);
export default __webpack_public_path__ + "static/media/RpoetSubCat.b7b1f935c2bd14fd6ae3b7e4a79c0f0f.svg";
export { ForwardRef as ReactComponent };